export class Profile {
  id: string;
  userName: string;
  email: string;
  registrationDate: Date;
}
